import * as z from "zod";

export const recordRecoverOnboardingStarted = {
  name: "recordRecoverOnboardingStarted" as const,
  input: z.object({}),
  output: z.object({}),
};
